import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../api/client';


const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userId = params.get('userId');
    if (userId) {
      localStorage.setItem('userId', userId);
      (async () => {
        try {
          const res = await api.get(`/users/${userId}/profile`);
          const url = res.data?.avatar_url || '';
          const dn = res.data?.display_name || '';
          if (url) {
            localStorage.setItem('avatar_url', url);
          }
          if (dn) localStorage.setItem('displayName', dn);
          if (!url) {
            try {
              const linked = await api.get(`/auth/linked`, { params: { userId } });
              const providers: string[] = Array.isArray(linked.data?.providers) ? linked.data.providers : [];
              if (providers.includes('google')) {
                const r = await api.post(`/users/${userId}/avatar-google-refresh`);
                const url2 = r.data?.avatar_url || '';
                if (url2) localStorage.setItem('avatar_url', url2);
              }
            } catch (_) {}
          }
        } catch (_) {}

        let dest = '/schedule';
        try {
          const usage = await api.get(`/users/${userId}/usage`);
          const tier = usage.data?.tier;
          if (typeof tier === 'string') {
            try {
              localStorage.setItem('userTier', tier);
            } catch {}
          }
        } catch {}
        
        navigate(dest);
      })();
    } else {
      navigate('/login');
    }
  }, [location.search, navigate]);

  return (
    <div className="container mt-5">
      <h3>Completing sign-in...</h3>
      <p>Please wait while we redirect you.</p>
    </div>
  );
};

export default OAuthCallback;
